import {
    ProfileCreationFunnelMode,
    ProfileCreationStep,
    ProfileCreationStepGroup,
    RoutesConfig,
} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import {LocationQuery, RouteLocationNormalized, RouteRecordRaw} from 'vue-router';

const ProfileCreationRouterHelper = {
    hasNoPreviousRoute: (from: RouteLocationNormalized): boolean => {
        return !from.name;
    },
    getFirstRouteOfGroup(routesConfig: RoutesConfig, stepGroup: ProfileCreationStepGroup): RouteRecordRaw {
        const firstRouteName = stepGroup === ProfileCreationStepGroup.SIGNUP ? routesConfig.creationFirstStep : routesConfig.completionFirstStep;
        const filteredRoutes = routesConfig.routes.filter((route) => route.name === firstRouteName && route.meta && route.meta.previousStep === null);

        if (filteredRoutes.length !== 1) {
            throw new Error(`getFirstRouteOfGroup must only contain one first route for group ${stepGroup}. Got ${filteredRoutes.length} route(s).`);
        }

        return filteredRoutes[0];
    },
    needStrategyConfiguration: (pathname: string): boolean => {
        return ProfileCreationRouterHelper.isFunnelModeStrategyActivated(pathname);
    },
    isFunnelModeStrategyActivated: (pathname: string): boolean => {
        return pathname.includes('/strategy');
    },
    isGoingToAStepOfGroup: (stepGroup: ProfileCreationStepGroup, to: RouteLocationNormalized): boolean => {
        return to?.meta?.stepGroup === stepGroup;
    },
    isGoingToFirstStepOfGroup: (routesConfig: RoutesConfig, stepGroup: ProfileCreationStepGroup, to: RouteLocationNormalized): boolean => {
        return to?.path === ProfileCreationRouterHelper.getFirstRouteOfGroup(routesConfig, stepGroup).path;
    },
    needsRedirectionToFirstStepOfGroup: (
        routesConfig: RoutesConfig,
        stepGroup: ProfileCreationStepGroup,
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
    ): boolean => {
        return (
            ProfileCreationRouterHelper.hasNoPreviousRoute(from) &&
            ProfileCreationRouterHelper.isGoingToAStepOfGroup(stepGroup, to) &&
            !ProfileCreationRouterHelper.isGoingToFirstStepOfGroup(routesConfig, stepGroup, to)
        );
    },
    routeIsAnAlias: (to: RouteLocationNormalized, aliases: string[]): boolean => {
        return to.path ? aliases.includes(to.path) : false;
    },
    buildRouteFromStep: (
        profileCreationStep: ProfileCreationStep,
        funnelMode: ProfileCreationFunnelMode = ProfileCreationFunnelMode.FREELANCER,
    ): RouteRecordRaw => {
        return {
            path: profileCreationStep.route,
            name: profileCreationStep.name,
            component: profileCreationStep.component,
            meta: {
                funnelMode,
                isFunnelStrategy: funnelMode === ProfileCreationFunnelMode.STRATEGY,
                stepGroup: profileCreationStep.group,
                stepNumber: profileCreationStep.stepNumber,
                stepCount: profileCreationStep.stepCount,
                progressPercentage: ProfileCreationRouterHelper.computeProgression(profileCreationStep.stepCount, profileCreationStep.stepNumber),
                previousStep: profileCreationStep.previousStepName,
                nextStep: profileCreationStep.nextStepName,
                trackingStepName: profileCreationStep.trackingName,
            },
        };
    },
    computeProgression: (totalStep: number, currentStep: number): number => {
        if (totalStep === currentStep) {
            return 95;
        }
        return Math.round((95 / totalStep) * currentStep);
    },
    redirectToExternalPath(path: string) {
        window.location.href = path;
    },
    handleInvitationCode(query: LocationQuery) {
        const invitationCode = query['mfi'];
        if (invitationCode) {
            localStorage.setItem('mfi-code', invitationCode.toString());
            delete query['mfi'];
        }
    },
};

export default ProfileCreationRouterHelper;
